import Nprogress from 'nprogress'

import { useAuthStore } from '@/stores/retailer/auth.js'

export default function retailerPolicyControl(to, from, next) {
  const authStore = useAuthStore()

  authStore.getUser().then(() => {
    const user = authStore.user
    const policyPath = '/retailer/policy'

    if (!user.retailer.is_policy_accepted && user.retailer.sales_channels.length > 0 && to.path !== policyPath) {
      if (from.path === policyPath) {
        Nprogress.done()
      }
      return next({
        name: 'retailer.policy'
      })
    } else if (user.retailer.is_policy_accepted && to.path === policyPath) {
      return next({
        name: 'retailer.dashboard'
      })
    } else {
      return next()
    }
  })
}
